import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-qrsplash',
  templateUrl: './qrsplash.component.html',
  styleUrls: ['./qrsplash.component.css']
})
export class QrsplashComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
